import { QuestsCategoryModel } from "../Api/Models/quests.model";

export const QUEST_CATEGORIES_CACHE_KEY = "questCategoriesCache";
const CACHE_DURATION_MS = 30 * 60 * 1000;

export const getCachedQuestCategories = (): QuestsCategoryModel[] | null => {
    const cached = localStorage.getItem(QUEST_CATEGORIES_CACHE_KEY);
    if (!cached) return null;

    const { data, timestamp } = JSON.parse(cached);
    if (Date.now() - timestamp > CACHE_DURATION_MS) {
        localStorage.removeItem(QUEST_CATEGORIES_CACHE_KEY);
        return null;
    }
    return data;
};

export const setCachedQuestCategories = (data: QuestsCategoryModel[]) => {
    localStorage.setItem(
        QUEST_CATEGORIES_CACHE_KEY,
        JSON.stringify({ data, timestamp: Date.now() })
    );
};